import { ModalWrapper, VimeoFrame, SmallVimeoFrame } from "../../utils/fw"
import { WhatsOnEverywhere } from "../components/WhatsOn"
import { isMember } from "../utils"
import { TimeSwitch } from "../../utils/fw"
import { TimedPopup } from "../components/TimedPopup"


const memberLinks = [
	{
		height: "25.9%",
		href: "/speaker-gallery",
		label: "Speaker Gallery",
		left: "4.5%",
		top: "29.3%",
		width: "9.2%",
	},
	{
		height: "25.5%",
		href: "/lounge",
		label: "Interactive Lounge",
		left: "4.5%",
		top: "55.9%",
		width: "8.5%",
	},
	{
		height: "13.6%",
		label: "What's On",
		left: "48.3%",
		top: "77.7%",
		width: "5.4%",
		modal: <ModalWrapper>
			<WhatsOnEverywhere />
		</ModalWrapper>
	},
	{
		label: "Exploration Zone",
		height: "24.2%",
		href: "/exploration-zone",
		onClick: () => window.openChat("isf-exploration-zone"),
		left: "56.2%",
		top: "12%",
		width: "13.6%",
	},
]

export default {
	background: "https://assets.swoogo.com/uploads/full/1384328-6156014fa9af0.jpg",
	default: true,
	extras: (
		<>
			<video autoPlay loop
				id="sponsor-banner-left"
				src="https://assets.swoogo.com/uploads/1403258-6164d8588ec23.mp4"
			/>
			<video autoPlay loop
				id="sponsor-banner-right"
				src="https://assets.swoogo.com/uploads/1403258-6164d8588ec23.mp4"
			/>
			<TimedPopup id="atrium-1" firesAt="2022-08-03 08:30+01:00">
				<h1>WELCOME TO DIGITAL 2021: DAY ONE</h1>
				<p>
					Today's keynote speakers are Professor Brian Cox and Steve Wozniak.
				</p>
				<p>
					Drop-in to the Roundtable room afer a breakout session to take part in the following discussion.
				</p>
				<p>
					Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape. Take part in the Passport to Prizes.
				</p>
				<p>
					Visit the Interactive Lounge and discover how you can gain points and improve your ranking on the Leaderboard for your chance to win more prizes.
				</p>
			</TimedPopup>
			<TimedPopup id="atrium-2" firesAt="2022-08-03 13:28+01:00">
				<p>
					Join the ISF Round Up in the Roundtable room, Interactive Lounge for a discussion on recent sessions.
				</p>
			</TimedPopup>
			<TimedPopup id="atrium-3" firesAt="2022-08-04 08:15+00:00">
				<h1>WELCOME TO DIGITAL 2021: DAY TWO</h1>
				<p>
					Today's keynote speakers are Viviane Reding and Professor Sadie Creese.
				</p>
				<p>
					Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members and tap into the knowledge of the ISF team.
				</p>
				<p>
					Remember to join the Roundtable sessions in the Interactive Lounge to discuss the latest information security trends.
				</p>
			</TimedPopup>
			<TimedPopup id="atrium-4" firesAt="2022-08-04 13:50+01:00">
				<p>
					Just launched: SOGP WebApp
				</p>
				<p>
					Look out for our email to learn more, and visit the Exploration Zone to watch our video and chat to us.
				</p>
				<p>
					Join our session: ISF Standard of Good Practice: exploring the new SOGP WebApp - check the schedule for times.
				</p>
			</TimedPopup>
			<TimedPopup id="atrium-5" firesAt="2022-08-04 17:00+01:00">
				<p>
					Join the ISF Round Up in the Roundtable room, Interactive Lounge for a discussion on recent sessions.
				</p>
			</TimedPopup>
			<TimedPopup id="atrium-6" firesAt="2022-08-05 08:15+01:00">
				<h1>WELCOME TO DIGITAL 2021: DAY THREE</h1>
				<p>
					Today's keynote speakers are Rachel Botsman and Dr Max McKeown.
				</p>
				<p>
					If you haven't already, you can connect one-to-one with the ISF team in the Exploration Zone.
				</p>
				<p>
					Today is the last chance to take part in the Passport to Prizes competition. Visit our sponsors in the Exhibition Hall to hunt for the letters. Enter before 17:00 UTC to win.
				</p>
			</TimedPopup>
			<TimedPopup id="atrium-7" firesAt="2022-08-05 13:50+01:00">
				<p>
					Just launched: QIRA Assistant
				</p>
				<p>
					Look out for our email to learn more, and visit the Exploration Zone to watch our video and chat to us.
				</p>
				<p>
					Join our live drop in: ISF QIRA Assistant Demonstration - check the schedule for times.
				</p>
			</TimedPopup>
			<TimedPopup id="atrium-8" firesAt="2022-08-05 17:00+01:00">
				<p>
				Join the ISF Round Up in the Roundtable room, Interactive Lounge for a discussion on recent sessions.
				</p>
			</TimedPopup>
			<TimedPopup id="atrium-9" firesAt="2022-08-06 08:15+01:00">
				<h1>THANK YOU FOR ATTENDING DIGITAL 2021</h1>
				<p>
					The Passport to Prizes draw has taken place and winners will be notified.
				</p>
				<p>
					Look out for your CPE certificate - notifications will be sent to attendees in the next few days.
				</p>
				<p>
					The Congress venue will remain open until Friday 19 November for you to browse content and watch sessions on demand.
				</p>
			</TimedPopup>
		</>
	),
	links: [
		{
			height: "11.9%",
			label: "Keynote Screen",
			left: "14.5%",
			top: "45.8%",
			width: "10.8%",
			modal: <TimeSwitch>
				{[
					{
						starts: "2021-10-23T00:00+01:00",
						ends: "2022-08-04T07:00+01:00",
						content: <VimeoFrame vidId="629251114?h=fdb3057c6f&autoplay=1" />,
					},
					{
						starts: "2022-08-04T07:00+01:00",
						ends: "2022-08-05T07:00+01:00",
						content: <VimeoFrame vidId="629249965?h=617238db45&autoplay=1" />,
					},
					{
						starts: "2022-08-05T07:00+01:00",
						ends: "2022-08-06T07:00+01:00",
						content: <VimeoFrame vidId="629250757?h=cdd12e39fd&autoplay=1" />,
					},
					{
						starts: "2022-08-06T07:00+01:00",
						ends: "2021-10-30T07:00+01:00",
						content: <VimeoFrame vidId="632833730?h=ec98f810a2&autoplay=1" />,
					},
				]}
			</TimeSwitch>
		},
		{
			height: "18.7%",
			href: "/breakouts",
			label: "Breakouts",
			left: "29%",
			top: "37.2%",
			width: "6.1%",
		},
		{
			height: "18%",
			href: "/exhibition-hall",
			label: "Exhibition Hall",
			left: "26.3%",
			top: "56.7%",
			width: "12.6%",
		},
		{
			height: "5.9%",
			href: "https://assets.swoogo.com/uploads/1406989-6166f0ef4492c.pdf",
			isExternal: true,
			label: "FAQs",
			left: "23.2%",
			target: "_blank",
			top: "77.1%",
			width: "5.4%",
		},
		{
			height: "7.9%",
			label: "Orientation Video",
			left: "23.2%",
			modal: <SmallVimeoFrame
				vidId="621805366?h=246b81c4df&autoplay=1"
			/>,
			top: "83.1%",
			width: "5.4%",
		},
		{
			height: "18.5%",
			label: "Information/Help Desk",
			onClick: () => openSmartSupp(),
			left: "29.8%",
			top: "75.6%",
			width: "17.4%",
		},
		{
			height: "23.2%",
			href: "/auditorium",
			onClick: () => window.openChat("keynotes"),
			label: "Main Auditorium",
			left: "57.5%",
			top: "52.6%",
			width: "11.9%",
		},
		{
			height: "15%",
			label: "Highlights Screen",
			left: "71.8%",
			top: "50.6%",
			width: "13.1%",
			modal: <TimeSwitch>
				{[
					{
						starts: "2021-10-23T00:00+01:00",
						ends: "2022-08-04T07:00+01:00",
						content: <VimeoFrame vidId="635166551?h=eb94bb8438&autoplay=1" />,
					},
					{
						starts: "2022-08-04T07:00+01:00",
						ends: "2022-08-05T07:00+01:00",
						content: <VimeoFrame vidId="635123270?h=891ceaab50&autoplay=1" />,
					},
					{
						starts: "2022-08-05T07:00+01:00",
						ends: "2022-08-06T07:00+01:00",
						content: <VimeoFrame vidId="635124610?h=8f84aecae8&autoplay=1" />,
					},
					{
						starts: "2022-08-06T07:00+01:00",
						ends: "2021-10-30T07:00+01:00",
						content: <VimeoFrame vidId="636323212?h=f328af67b1&autoplay=1" />,
					},
				]}
			</TimeSwitch>
		},
		...(isMember ? memberLinks : []),
	],
	name: "atrium",
}
